import { BaseComponent } from './components/base/base.component';
import { DataSessionService } from 'src/app/services/commons/data-session.service';
import { Component, OnInit } from '@angular/core';
import { AuthService } from './services/commons/auth.service';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import jsonpack from '../../package.json'
import { CommonService } from './services/commons/commons.service';
import User from './models/user';
import * as Highcharts from 'highcharts';
(window as any)._Highcharts = Highcharts;

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  standalone: false
})
export class AppComponent extends BaseComponent implements OnInit {

  public appPages: any[] = [];
  //goldValue:number = 0;
  valueUp: boolean = true;
  version: string = "";
  hideToolbar: boolean = false;
  hideMenu: boolean = false;

  constructor(
    private authServices: AuthService,
    private _router: Router,
    public dataSessionServ: DataSessionService,
    private commonServices: CommonService
  ) {
    super(dataSessionServ, commonServices, _router);    
  }
  user?: User;
  override ngOnInit(): void {
    super.ngOnInit();

    

    // this.activatedRoute.paramMap.subscribe(params => {
    //   const slug = params.get('url');
    //   console.log('LUCA -> ', slug);
    // });

    this._router.events.subscribe((event: any|NavigationEnd) => {
      if (event instanceof NavigationEnd === false) { return; }
      
      const currentUrl = event.urlAfterRedirects;
      const urlsNoToolbar = ['/charts','/quotazioni'];
      const urlsNoMenu = ['/charts','/quotazioni'];
      this.hideToolbar = urlsNoToolbar.findIndex((url) => url === currentUrl) > -1;
      this.hideMenu = urlsNoMenu.findIndex((url) => url === currentUrl) > -1;

    });
  

    this.dataSessionServ.loggedUser$.subscribe(
      (user) => {
        this.user = user as User;
        this.appPages = [
          { title: 'Amministrazione', url: '/admin', icon: 'shield', show: this.user?.level == 'admin' },
          { title: 'Il mio pannello', url: '/dashboard', icon: 'mail', show: true },
          { title: 'Mio ORO', url: '/deposito/v', icon: 'paper-plane', show: true },
          { title: 'Acquista Lingotti', url: '/lingotti', icon: 'heart', show: true },
          { title: 'Piano ORO', url: '/piano-oro', icon: 'archive', show: true },
          { title: 'Conto ORO', url: '/lingotti/c', icon: 'archiv1', show: true },
          { title: 'Deposito ORO', url: '/magazino', icon: 'archiv1', show: this.user?.level == 'admin' },
          { title: 'Movimentazioni', url: '/movimentazioni', icon: 'trash', show: true },
          { title: 'Sito', url: '/website', icon: 'warning', show: false },
          { title: 'Esci', url: null, click: '', icon: 'warning', show: true },
        ];
      });
    this.version = jsonpack.version;
    this.dataSessionServ.goldValue$.subscribe(
      (value: any) => {
        this.valueUp = this.goldValue < value
        this.goldValue = value != null ? value : 0;
      }

    )
    this.dataSessionServ.getGoldValue();
    console.log("ECCO UTENTE: ", this.loggedUser)
  }

  onActivate(component: any) {
    if (component.onComponentIsActive)
      component.onComponentIsActive();
  }

  isActive(url: string): boolean {
    //console.log("active: ",this._router.url === url)
    return this._router.url === url;
  }

  logout() {
    this.authServices.logout().then(
      r => {
        this._router.navigate(['/login'])
      }
    );
  }

  routeTo(url:string){
    this._router.navigate([url]);
  }
}
